import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { CircularProgress } from "@mui/material";
import chatDummyImage from "../assets/chat-dummy-image.png";
import expandIcon from "../assets/expand-icon.svg";
import RefreshIcon from "../assets/caseMappingIcon.svg";

import expandIconWhite from "../assets/expandIconWhite.svg";
import shrinkIcon from "../assets/shrinkIcon.svg";
import upwardExpandIcon from "../assets/upward-expand-icon.svg";
import editIcon from "../assets/edit-pencil-icon.svg";
import downloadIcon from "../assets/download-new-icon.svg";
import pencilIcon from "../assets/pencil-icon.svg";
import MoveIcon from "../assets/moveIcon.svg";
import starIcon from "../assets/star-icon.svg";
import flagIcon from "../assets/flag-icon.svg";
import stretchIcon from "../assets/stretch-icon.svg";
import refreshIcon from "../assets/refresh-icon.svg";
import leftPaginationIcon from "../assets/left-pagination-arrow.svg";
import rightPaginationIcon from "../assets/right-pagination-icon.svg";
import blackChatIcon from "../assets/black-chat-icon.svg";
import leftIcon from "../assets/leftIcon.svg";
import rightIcon from "../assets/rightIcon.svg";
import NewDutAccordion from "./NewDutAccordion";
import eyeNewIcon from "../assets/eye-new-icon.svg";
import checkedThumbnailIcon from "../assets/thumbnailChecked.svg";
import uncheckedThumbnailIcon from "../assets/thumbnailUnchecked.svg";
import redThumbnailCheckedIcon from "../assets/redCheckedIcon.svg";
import redThumbnailUncheckedIcon from "../assets/redUncheckedIcon.svg";
import clippedIcon from "../assets/clippedIcon.svg";
import DownloadMultipleDocuments from "../dashboard/cases/updatedocuments/DownloadMultipleDocuments";
import { toast } from "react-toastify";
import { CaseServices } from "../services/CaseServices";
import { CommentServices } from "../services/CommentServices";
import { getUser } from "../config/user";
import SendIcon from "../assets/sendIconLatest.svg";
import settlemedLogo from "../assets/settlemedLogo.svg";
import zoomInIcon from "../assets/zoomInIcon.svg";
import zoomOutIcon from "../assets/zoomOutIcon.svg";
import hospitalIcon from "../assets/hospitalIcon.svg";
import pencilIconNew from "../assets/pencil-icon-new.svg";
import crossNewIcon from "../assets/crossNewIcon.svg";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";

const ClaimInsightsScreen = ({
  selectedCase,
  dutData,
  latestStageData,
  selectedDocument,
  setSelectedDocument,
  selectedImg,
  setSelectedImg,
  fetchLatestCaseStage,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [showReApprove, setShowReApprove] = useState(false);
  const [showDeniedPopup, setShowDeniedPopup] = useState(false);
  const [showDeniedOverlay, setShowDeniedOverlay] = useState(false);
  const [showDeniedMiniPopUp, setShowDeniedMiniPopUp] = useState(false);
  const [showDeniedReason, setShowDeniedReason] = useState(false);
  const [deniedReason, setDeniedReason] = useState("");
  const [showDeniedSuccessPopup, setShowDeniedSuccessPopup] = useState(false);
  const [move, setMove] = useState(false);
  const [moveDocument, setMoveDocument] = useState(null);
  const [isEditingInsights, setIsEditingInsights] = useState(false);
  const [editableScrapData, setEditableScrapData] = useState({});
  const [openMultipleDownloads, setOpenMultipleDownloads] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(100);
  const [rotation, setRotation] = useState(0);
  const [pageGroupStart, setPageGroupStart] = useState(0);
  const [openChatBox, setOpenChatBox] = useState(false);
  const [comments, setComments] = useState([]);
  const [message, setMessage] = useState("");
  const [users, setUsers] = useState({});
  const [isExpandedView, setIsExpandedView] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [saveAll, setSaveAll] = useState(0);
  const [selectedImages, setSelectedImages] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const user = getUser();
  const navigate = useNavigate();
  const reviewWrapperRef = useRef(null);
  const reviewContentRef = useRef(null);
  const chatContainerRef = useRef(null);

  const [fullHeight, setFullHeight] = useState(0);
  const previewHeight = fullHeight * 0.1;
  const originalHeightRef = useRef(0);
  const outerWrapperRef = useRef(null);
  const documents = latestStageData?.documents || [];
  const isCurrentImageRejected = selectedImg?.status === "REJECTED";

  const currentImageRejectionReason = selectedImg?.rejectionReason || "";
  const thumbnailContainerRef = useRef(null);
  const handleMove = () => {
    setMove((prev) => !prev);
  };
  const handleMoveDocument = async () => {
    try {
      if (!moveDocument?.id) {
        toast.error("Please select a document");
        return;
      }

      if (moveDocument.id === selectedDocument.id) {
        toast.error("Image already belongs to selected document");
        return;
      }

      const alreadyExists = moveDocument?.documenturlmasters?.some(
        (img) => img?.documentUrl === selectedImg?.documentUrl,
      );

      if (alreadyExists) {
        toast.error("Image already moved to selected document");
        return;
      }
      const imagesToMove =
        selectedImages.length > 0 ? selectedImages : [selectedImg];
      const alreadyMovedImages = imagesToMove.filter((img) =>
        moveDocument?.documenturlmasters?.some(
          (targetImg) => targetImg.documentUrl === img.documentUrl,
        ),
      );

      if (alreadyMovedImages.length) {
        toast.error(
          `${alreadyMovedImages.length} image(s) already exist in target document`,
        );
        return;
      }

      const payload = imagesToMove.map((img, index) => ({
        sequence: (moveDocument?.documenturlmasters?.length || 0) + index + 1,
        documentUrl: img.documentUrl,
      }));

      const response = await CaseServices.saveDocumentUrl(
        moveDocument.id,
        payload,
        false,
        true,
      );

      toast.success(response?.data?.message || "Moved successfully");

      setMove(false);
      setMoveDocument(null);

      await fetchLatestCaseStage();
    } catch (error) {
      console.log("MOVE ERROR", error);
    }
  };
  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 10, 300));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 10, 50));
  };
  const handleRotate = () => {
    setRotation((prev) => (prev + 90) % 360);
  };

  const handleImageSelection = (image) => {
    setSelectedImages((prev) => {
      const exists = prev.some((item) => item.id === image.id);

      if (exists) {
        return prev.filter((item) => item.id !== image.id);
      }

      return [...prev, image];
    });
  };
  const handleDocumentReject = async () => {
    try {
      if (!deniedReason?.trim()) {
        alert("Please enter denial reason");
        return;
      }

      await CaseServices.updateDocumentStatus(selectedDocument.id, {
        status: "REJECTED",
        rejectedUrlIds: [
          {
            id: selectedImg.id,
            rejectionReason: deniedReason,
          },
        ],
        restrictCaseStageUpdate: true,
      });

      await fetchLatestCaseStage();
      toast.success("Document rejected successfully");

      setShowDeniedPopup(false);
      setShowDeniedOverlay(true);
      setShowDeniedSuccessPopup(true);
      setShowDeniedReason(false);
    } catch (error) {
      console.log("Reject API Error", error);
    }
  };
  const handleDocumentReApprove = async () => {
    const approvalReason = window.prompt("Please enter the approval reason:");
    if (!approvalReason || approvalReason.trim() === "") {
      alert("Approval reason is required.");
      return;
    }
    try {
      await CaseServices.updateDocumentStatus(selectedDocument.id, {
        status: "APPROVED",
        restrictCaseStageUpdate: true,
        approvalReason: approvalReason.trim(),
      });

      await fetchLatestCaseStage();
      setShowDeniedOverlay(false);
      setShowDeniedPopup(false);
      setShowDeniedSuccessPopup(false);
      setShowDeniedMiniPopUp(false);
    } catch (error) {
      console.log("Reject API Error", error);
    }
  };
  const handleHoldClick = async () => {
    setSubmitting(true);
    const documentType = latestStageData?.documents[0]?.documentType;
    try {
      const res = await CaseServices.holdRejectedCaseByAI(
        latestStageData?.currnetSubMasterStage[0]?.caseId,
        documentType,
      );
      // window.alert(res?.data?.message);
      navigate("/dashboard/ActiveCases");
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSubmitting(false);
  };
  const handleSubmitClick = async () => {
    setSubmitting(true);
    const shouldCallApi = latestStageData?.documents?.every((doc) => {
      return (
        doc?.status !== "REJECTED" &&
        (doc?.aiReason?.aiStatus !== "REJECTED" || doc?.status === "APPROVED")
      );
    });
    if (!shouldCallApi) {
      setSubmitting(false);
      console.log("should call api:", shouldCallApi);
      window.alert("Approve all the documents before proceeding");
      return;
    }
    const postStageData = {
      caseIds: [latestStageData?.currnetSubMasterStage[0]?.caseId],
    };
    try {
      const stageResponse =
        await CaseServices.updateCaseProcessByAI(postStageData);
      navigate("/dashboard/ActiveCases");
    } catch (error) {
      handleApiErrorResponses(error);
    }

    setSubmitting(false);
  };

  const handleThumbnailClick = (image, idx) => {
    setSelectedImg({
      idx,
      ...image,
    });
  };

  const getUsers = async () => {
    try {
      const res = await CommentServices.getAllUserDetail();
      setUsers(res?.data?.users || {});
    } catch (error) {
      console.error(error);
    }
  };

  const getDocComments = async () => {
    try {
      if (!selectedImg?.id) return;

      const res = await CommentServices.getDocumentComments(
        true,
        selectedImg.id,
      );

      setComments(res?.data?.documentDetails?.comments || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCommentAdd = async () => {
    if (!message?.trim()) return;

    try {
      await CommentServices.sendComment({
        documentId: selectedImg.id,
        message,
        commentOn: "CASEDOCUMENT",
      });

      setMessage("");
      await getDocComments();
    } catch (error) {
      console.error(error);
    }
  };

  const scrapData = selectedDocument?.scrapData?.current || {};
  const basicFields = Object.entries(scrapData).filter(
    ([, value]) => !Array.isArray(value) && typeof value !== "object",
  );

  const objectFields = Object.entries(scrapData).filter(
    ([, value]) => value && typeof value === "object" && !Array.isArray(value),
  );

  const arrayFields = Object.entries(scrapData).filter(([, value]) =>
    Array.isArray(value),
  );

  const handlePrevImage = () => {
    if (!selectedDocument?.documenturlmasters?.length) return;

    const currentIdx = selectedImg?.idx ?? 0;

    if (currentIdx <= 0) return;

    const prevImage = selectedDocument.documenturlmasters[currentIdx - 1];

    setSelectedImg({
      idx: currentIdx - 1,
      ...prevImage,
    });
  };

  const handleNextImage = () => {
    if (!selectedDocument?.documenturlmasters?.length) return;

    const currentIdx = selectedImg?.idx ?? 0;

    if (currentIdx >= selectedDocument.documenturlmasters.length - 1) return;

    const nextImage = selectedDocument.documenturlmasters[currentIdx + 1];

    setSelectedImg({
      idx: currentIdx + 1,
      ...nextImage,
    });
  };

  const handlePrevImageThumbnail = () => {
    if (!selectedDocument?.documenturlmasters?.length || selectedImg?.idx <= 0)
      return;

    const prevIndex = selectedImg.idx - 1;

    setSelectedImg({
      ...selectedDocument.documenturlmasters[prevIndex],
      idx: prevIndex,
    });
  };

  const handleScrapDataSave = async () => {
    try {
      await CaseServices.updateDocumentScrapData(
        {
          scrapData: editableScrapData,
        },
        selectedDocument.id,
      );

      toast.success("Scrap data updated successfully");

      setIsEditingInsights(false);

      await fetchLatestCaseStage();
    } catch (error) {
      console.log("SCRAP UPDATE ERROR", error);
      toast.error("Failed to update scrap data");
    }
  };

  const handleNextImageThumbnail = () => {
    if (
      !selectedDocument?.documenturlmasters?.length ||
      selectedImg?.idx >= selectedDocument.documenturlmasters.length - 1
    )
      return;

    const nextIndex = selectedImg.idx + 1;

    setSelectedImg({
      ...selectedDocument.documenturlmasters[nextIndex],
      idx: nextIndex,
    });
  };

  const PAGE_GROUP_SIZE = 6;

  const totalPages = selectedDocument?.documenturlmasters?.length || 0;

  const safePageGroupStart = pageGroupStart >= totalPages ? 0 : pageGroupStart;

  const visiblePages =
    selectedDocument?.documenturlmasters?.slice(
      safePageGroupStart,
      safePageGroupStart + PAGE_GROUP_SIZE,
    ) || [];

  const handleReprocessAiCase = async (cas) => {
    const data = {
      caseIds: [cas.id],
    };
    try {
      const res = await CaseServices?.reProcessAiAnalysisCases(data);
      navigate("/dashboard/ActiveCases");
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        if (!outerWrapperRef.current) {
          ticking = false;
          return;
        }

        const rect = outerWrapperRef.current.getBoundingClientRect();

        const shouldPreview = rect.bottom <= previewHeight + 80;

        setIsPreviewMode((prev) =>
          prev !== shouldPreview ? shouldPreview : prev,
        );

        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!chatContainerRef.current) return;

    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
  }, [comments]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        handlePrevImageThumbnail();
      }

      if (e.key === "ArrowRight") {
        handleNextImageThumbnail();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedImg, selectedDocument]);

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (selectedImg?.id) {
      getDocComments();
    }
  }, [selectedImg?.id]);

  const currentDocumentId = selectedDocument?.id;
  const currentImageId = selectedImg?.id;

  useEffect(() => {
    if (!documents.length) return;

    // First load only
    if (!selectedDocument?.id) {
      const firstDocument = documents[0];

      setSelectedDocument(firstDocument);

      if (firstDocument?.documenturlmasters?.length) {
        setSelectedImg({
          idx: 0,
          ...firstDocument.documenturlmasters[0],
        });
      }

      return;
    }

    // Preserve selected document
    const updatedDocument = documents.find(
      (doc) => doc.id === selectedDocument.id,
    );

    if (!updatedDocument) return;

    setSelectedDocument(updatedDocument);

    // Preserve selected image
    const updatedImageIndex = updatedDocument.documenturlmasters?.findIndex(
      (img) => img.id === selectedImg?.id,
    );

    if (updatedImageIndex >= 0) {
      setSelectedImg({
        idx: updatedImageIndex,
        ...updatedDocument.documenturlmasters[updatedImageIndex],
      });
    }
  }, [documents]);

  useEffect(() => {
    setPageGroupStart(0);
  }, [selectedDocument?.id]);

  // useEffect(() => {
  //   if (reviewContentRef.current) {
  //     originalHeightRef.current = reviewContentRef.current.offsetHeight;

  //     setFullHeight(reviewContentRef.current.offsetHeight);
  //   }
  // }, [selectedDocument]);

  useEffect(() => {
    if (!reviewContentRef.current) return;

    const timer = setTimeout(() => {
      const height = reviewContentRef.current.offsetHeight;

      originalHeightRef.current = height;
      setFullHeight(height);
    }, 100);

    return () => clearTimeout(timer);
  }, [selectedDocument, selectedImg]);

  useEffect(() => {
    if (!selectedImg) return;

    // Always reset temporary popup states
    setShowDeniedPopup(false);
    setShowDeniedReason(false);
    setShowDeniedMiniPopUp(false);
    setShowDeniedOverlay(false);
    if (
      selectedDocument?.status !== "APPROVED" &&
      (selectedImg.status === "REJECTED" ||
        selectedDocument?.aiReason?.aiStatus === "REJECTED")
    ) {
      // setShowDeniedOverlay(true);
      // setShowDeniedSuccessPopup(true);
      setShowDeniedMiniPopUp(true);
    } else {
      // setShowDeniedOverlay(false);
      // setShowDeniedSuccessPopup(false);
      setShowDeniedMiniPopUp(false);
    }
  }, [selectedImg?.id]);

  useEffect(() => {
    setDeniedReason("");
  }, [selectedImg?.id]);

  useEffect(() => {
    setEditableScrapData(scrapData || {});
  }, [selectedDocument]);

  useEffect(() => {
    setZoomLevel(100);
    setRotation(0);
  }, [selectedImg?.id]);

  useEffect(() => {
    if (!thumbnailContainerRef.current) return;

    const container = thumbnailContainerRef.current;
    const selectedThumbnail = container.children?.[selectedImg?.idx];

    if (selectedThumbnail) {
      container.scrollTo({
        left:
          selectedThumbnail.offsetLeft -
          container.clientWidth / 2 +
          selectedThumbnail.clientWidth / 2,
        behavior: "smooth",
      });
    }
  }, [selectedImg?.idx]);

  // useEffect(() => {
  //   const totalUnread =
  //     selectedDocument?.documenturlmasters?.reduce(
  //       (sum, img) => sum + (img.totalUnreadComments || 0),
  //       0,
  //     ) || 0;

  //   setUnreadCommentCount(totalUnread);
  // }, [selectedDocument]);

  return (
    <div className="w-full h-full pt-20  bg-[radial-gradient(81.98%_338.81%_at_13.41%_276.08%,rgba(90,198,159,0.5)_0%,rgba(222,222,222,0.5)_100%)]">
      {" "}
      {/* Top Toolbar */}
      <div
        ref={outerWrapperRef}
        style={{
          height: `${fullHeight}px`,
          position: "relative",
        }}
      >
        <div
          ref={reviewWrapperRef}
          className={isPreviewMode ? "fixed z-40" : ""}
          style={{
            ...(isPreviewMode && {
              top: "80px",
              left: "172px",
              right: "0",
              width: "calc(100% - 172px)",
            }),

            height: isPreviewMode ? `${previewHeight}px` : `${fullHeight}px`,

            overflow: "hidden",
          }}
        >
          <div
            ref={reviewContentRef}
            style={{
              transform: isPreviewMode
                ? `translateY(-${fullHeight - previewHeight}px)`
                : "translateY(0)",
            }}
          >
            <div className="flex gap-[16px] p-[24px]">
              {/* Left Image */}
              <div
                className={`transition-all duration-300 ${
                  isExpandedView ? "w-full" : "w-[60%]"
                }`}
              >
                {/* Top Toolbar */}
                <div className="w-full flex items-center justify-between mb-[16px] px-[6px] ">
                  {/* Column 1 - Left Tools */}
                  {/* Column 1 - Left Tools */}
                  <div className="flex items-center gap-[6px]">
                    {/* Reject */}
                    <button
                      onClick={() => {
                        setShowDeniedOverlay(true);
                        setShowDeniedPopup(true);

                        // IMPORTANT
                        setShowDeniedSuccessPopup(false);
                      }}
                      className="pr-2 py-[6px] xl:text-[10px] rounded-full border border-[#FF4D4F] bg-white"
                    >
                      DOCS DENIED
                    </button>

                    {/* Download */}
                    <button
                      onClick={() => setOpenMultipleDownloads(true)}
                      className="border-none bg-transparent p-0 flex items-center justify-center"
                    >
                      <img src={downloadIcon} alt="download" />
                    </button>

                    {/* Patient Information Tooltip */}
                    <div className="relative group">
                      <button
                        type="button"
                        className="border-none bg-transparent p-0 flex items-center justify-center"
                      >
                        <div className="w-[22px] h-[22px] rounded-full border border-[#1A1A1A] flex items-center justify-center font-lufga text-[12px] font-medium text-[#1A1A1A]">
                          i
                        </div>
                      </button>

                      {/* Tooltip */}
                      <div className="absolute left-0 top-full mt-[8px] hidden group-hover:block z-[100]">
                        <div className="w-[280px] rounded-[14px] bg-white border border-[#E1E1E1] shadow-[0_4px_20px_rgba(0,0,0,0.12)] px-[16px] py-[14px]">
                          <div className="font-lufga font-medium text-[14px] text-[#1A1A1A] mb-[12px]">
                            Patient Details
                          </div>

                          <div className="flex flex-col gap-[10px]">
                            {/* Patient Name */}
                            <div className="flex justify-between gap-[16px]">
                              <span className="font-lufga font-light text-[11px] text-[#8B8B8B]">
                                Patient Name
                              </span>
                              <span className="font-lufga font-normal text-[11px] text-[#1A1A1A] text-right break-words">
                                {selectedCase?.patient?.patientName || "----"}
                              </span>
                            </div>

                            {/* Registration ID */}
                            <div className="flex justify-between gap-[16px]">
                              <span className="font-lufga font-light text-[11px] text-[#8B8B8B]">
                                Registration ID
                              </span>
                              <span className="font-lufga font-normal text-[11px] text-[#1A1A1A] text-right break-words">
                                {selectedCase?.pmjayRegistrationId || "----"}
                              </span>
                            </div>

                            {/* Beneficiary No. */}
                            <div className="flex justify-between gap-[16px]">
                              <span className="font-lufga font-light text-[11px] text-[#8B8B8B]">
                                Beneficiary No.
                              </span>
                              <span className="font-lufga font-normal text-[11px] text-[#1A1A1A] text-right break-words">
                                {selectedCase?.patient?.beneficiaryNo || "----"}
                              </span>
                            </div>

                            {/* Registered Date */}
                            <div className="flex justify-between gap-[16px]">
                              <span className="font-lufga font-light text-[11px] text-[#8B8B8B]">
                                Registered Date
                              </span>
                              <span className="font-lufga font-normal text-[11px] text-[#1A1A1A] text-right">
                                {selectedCase?.patient?.registeredDate
                                  ? new Date(
                                      selectedCase.patient.registeredDate,
                                    ).toLocaleString("en-GB", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    })
                                  : "----"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Column 2 - Zoom Controls */}
                  <div className="flex items-center gap-[14px] ">
                    <button
                      className="border-none bg-transparent p-0 flex items-center justify-center"
                      onClick={() => setIsExpandedView((prev) => !prev)}
                    >
                      <img src={stretchIcon} alt="stretch" />
                    </button>

                    <button
                      onClick={handleZoomOut}
                      className="font-lufga border-none bg-transparent p-0 text-[18px] text-[#1A1A1A] flex items-center justify-center"
                    >
                      <img src={zoomInIcon} alt="stretch" />
                    </button>

                    <span className="font-lufga font-normal text-[14px] leading-[14px] tracking-[-0.03em] text-[#1A1A1A]">
                      <span>{zoomLevel}%</span>
                    </span>

                    <button
                      onClick={handleZoomIn}
                      className="font-lufga border-none bg-transparent p-0 text-[18px] text-[#1A1A1A] flex items-center justify-center"
                    >
                      <img src={zoomOutIcon} alt="stretch" />
                    </button>

                    {isExpandedView && (
                      <button
                        onClick={handleRotate}
                        className="border-none bg-transparent p-0 flex items-center justify-center"
                      >
                        <img src={refreshIcon} alt="rotate" />
                      </button>
                    )}
                  </div>

                  {/* Column 3 - Clear */}
                  <button
                    onClick={() => setIsExpandedView(false)}
                    className="font-lufga font-normal border-none bg-transparent p-0 text-[12px] leading-[12px] tracking-[-0.03em] text-[#FF4D4F]"
                  >
                    Clear
                  </button>

                  {/* Column 4 - Pagination */}
                  <div className="flex items-center gap-[10px] pr-[16px]">
                    {/* Previous */}
                    <button
                      className="border-none"
                      onClick={() => {
                        const currentIndex = selectedImg?.idx || 0;

                        if (currentIndex > 0) {
                          const prevIndex = currentIndex - 1;

                          const prevImage =
                            selectedDocument.documenturlmasters[prevIndex];

                          setSelectedImg({
                            idx: prevIndex,
                            ...prevImage,
                          });

                          if (prevIndex < pageGroupStart) {
                            setPageGroupStart((prev) => prev - 1);
                          }
                        }
                      }}
                    >
                      <img
                        src={leftPaginationIcon}
                        alt="previous"
                        className="w-[8px] h-[8px]"
                      />
                    </button>

                    {/* Page Number */}
                    <div className="flex items-center gap-[6px]">
                      {visiblePages.map((_, idx) => {
                        const actualIndex = pageGroupStart + idx;

                        return (
                          <div
                            key={actualIndex}
                            onClick={() => {
                              const image =
                                selectedDocument.documenturlmasters[
                                  actualIndex
                                ];

                              setSelectedImg({
                                idx: actualIndex,
                                ...image,
                              });
                            }}
                            className={`w-[18px] h-[18px] rounded-full flex justify-center items-center font-lufga text-[10px] cursor-pointer
      ${
        selectedImg?.idx === actualIndex
          ? "bg-black text-white"
          : "border border-[#1A1A1A] text-[#1A1A1A]"
      }`}
                          >
                            {actualIndex + 1}
                          </div>
                        );
                      })}
                    </div>

                    {/* Next */}
                    <button
                      className="border-none"
                      onClick={() => {
                        const currentIndex = selectedImg?.idx || 0;

                        const totalPages =
                          selectedDocument?.documenturlmasters?.length || 0;

                        if (currentIndex < totalPages - 1) {
                          const nextIndex = currentIndex + 1;

                          const nextImage =
                            selectedDocument.documenturlmasters[nextIndex];

                          setSelectedImg({
                            idx: nextIndex,
                            ...nextImage,
                          });

                          if (
                            nextIndex >= pageGroupStart + PAGE_GROUP_SIZE &&
                            pageGroupStart + PAGE_GROUP_SIZE < totalPages
                          ) {
                            setPageGroupStart((prev) => prev + 1);
                          }
                        }
                      }}
                    >
                      <img
                        src={rightPaginationIcon}
                        alt="next"
                        className="w-[8px] h-[8px]"
                      />
                    </button>
                  </div>
                </div>

                {/* Image */}
                {/* Image */}
                <div className="relative w-full flex-shrink-0 h-[90%] bg-white rounded-[24px]  overflow-hidden flex flex-col">
                  {" "}
                  <div className="mb-[16px] px-[12px]">
                    <h2 className="font-lufga font-medium text-[24px] xl:text-[18px] 2xl:text-[22px] leading-[110%] tracking-[-0.03em] text-black text-center break-words">
                      {selectedDocument?.documentName || "Document"}
                    </h2>
                  </div>
                  {/* Document Name */}
                  {/* Image */}
                  {/* Document Name */}
                  {/* <div className="absolute top-[16px] left-[16px] z-10">
                    <h2 className="font-lufga font-medium text-[24px] xl:text-[18px] 2xl:text-[22px] leading-[100%] tracking-[-0.03em] text-black">
                      {selectedDocument?.documentName || "Document"}
                    </h2>
                  </div> */}
                  {/* Move Button */}
                  {move ? (
                    <div className="absolute top-[50%] left-1/2 -translate-x-1/2 -translate-y-1/2 z-40">
                      <div className="flex items-center gap-[14px] bg-white border border-[#E8E8E8] py-3 px-4 rounded-full shadow-md">
                        <Select
                          placeholder="Document Name"
                          options={documents.filter(
                            (doc) => doc.id !== selectedDocument?.id,
                          )}
                          getOptionLabel={(option) => option.documentName}
                          getOptionValue={(option) => option.id}
                          onChange={(item) => setMoveDocument(item)}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              width: "300px",
                              borderColor: "#017C57",
                              borderRadius: 999,
                              boxShadow: state.isFocused
                                ? "0 0 0 1px #017C57"
                                : "none",
                              "&:hover": {
                                borderColor: "#017C57",
                              },
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#017C57",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: "#017C57",
                            }),
                            input: (base) => ({
                              ...base,
                              color: "#017C57",
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: "#017C57",
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                        />

                        <div className="flex items-center gap-[10px]">
                          <div
                            className={`px-[25px] py-[11.5px] rounded-full ${
                              moveDocument
                                ? "bg-[#017C57] text-white cursor-pointer"
                                : "bg-[#D9D9D9] text-[#8B8B8B] cursor-not-allowed"
                            }`}
                            onClick={() => moveDocument && handleMoveDocument()}
                          >
                            SAVE
                          </div>

                          <div
                            className="text-[#0c0c0c] bg-[#ec0505] border border-[#D9D9D9] px-[25px] py-[11.5px] rounded-full cursor-pointer"
                            onClick={() => {
                              setMove(false);
                              setMoveDocument(null);
                            }}
                          >
                            CANCEL
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="absolute bottom-[25%] left-[45%] z-20">
                      <button
                        type="button"
                        onClick={handleMove}
                        className="w-[97px] h-[40px] rounded-[24px] border border-[#5AC69F] backdrop-blur-[2.5px] saturate-150 bg-[#017C574D] shadow-[0_4px_12px_rgba(0,0,0,0.12),inset_0_1px_0_rgba(255,255,255,0.6)] px-[16px] flex items-center justify-center gap-[16px]"
                      >
                        <span className="font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.37px] uppercase text-black">
                          MOVE
                        </span>

                        <img
                          src={MoveIcon}
                          alt="move-icon"
                          className="w-[18px] h-[18px] object-contain"
                        />
                      </button>
                    </div>
                  )}
                  {/* Left Navigation */}
                  {selectedDocument?.documenturlmasters?.length > 1 && (
                    <button
                      onClick={handlePrevImage}
                      className="absolute left-[12px] top-1/2 -translate-y-1/2 z-10 border-none bg-transparent p-0"
                    >
                      <img src={leftIcon} alt="previous" />
                    </button>
                  )}
                  {/* Right Navigation */}
                  {selectedDocument?.documenturlmasters?.length > 1 && (
                    <button
                      onClick={handleNextImage}
                      className="absolute right-[12px] top-1/2 -translate-y-1/2 z-10 border-none bg-transparent p-0"
                    >
                      <img src={rightIcon} alt="next" />
                    </button>
                  )}
                  <div
                    className={`flex-1 min-h-0 ${
                      zoomLevel > 100 ? "overflow-auto" : "overflow-hidden"
                    }`}
                  >
                    <img
                      src={selectedImg?.documentUrl || chatDummyImage}
                      alt="claim document"
                      className="w-full h-full rounded-[24px]"
                      style={{
                        transform: `scale(${zoomLevel / 100}) rotate(${rotation}deg)`,
                        transformOrigin: "center center",
                        transition: "transform 0.2s ease",
                      }}
                    />
                  </div>
                  {showDeniedMiniPopUp && (
                    <div className="absolute bottom-2 right-2 z-10 border-solid border-[1px] border-[#FF4343] bg-[#FF43434D] px-4 pb-[30px] rounded-[24px]">
                      <div className="flex justify-end pr-3 pt-3">
                        <img
                          src={expandIconWhite}
                          alt="icon"
                          onClick={() => {
                            console.log("button clicked");
                            setShowDeniedOverlay(true);
                            // setShowDeniedPopup(true);
                            setShowDeniedSuccessPopup(true);
                            setShowDeniedMiniPopUp(false);
                          }}
                        />
                      </div>
                      <h2 className="font-lufga font-normal text-[32px] leading-[100%] tracking-[-0.39px] text-center text-white capitalize">
                        {selectedDocument?.aiReason?.displayAiStatus ===
                        "RECTIFIED"
                          ? "Rectified Docs!"
                          : "Docs Denied!"}
                      </h2>
                      <div className="flex justify-center">
                        <button
                          onClick={handleDocumentReApprove}
                          className="mt-[4px] w-[100px] h-[40px] rounded-[24px] border border-none bg-white flex items-center justify-center font-lufga font-normal text-[12px] text-black"
                        >
                          {selectedDocument?.aiReason?.displayAiStatus ===
                          "RECTIFIED"
                            ? "Approve"
                            : "Re-Approve"}
                        </button>
                      </div>

                      {/* View Reason */}
                      <div
                        onClick={() => {
                          setShowDeniedReason(true);
                          console.log("button clicked");
                          setShowDeniedOverlay(true);
                          // setShowDeniedPopup(true);
                          setShowDeniedSuccessPopup(true);
                          setShowDeniedMiniPopUp(false);
                        }}
                        className="mt-[18px] text-white font-lufga font-normal border border-none text-[12px] leading-[100%] underline cursor-pointer"
                      >
                        View Document Denied Reason
                      </div>
                    </div>
                  )}
                  {/* this is to shw the red border  */}
                  {(showDeniedOverlay ||
                    showDeniedMiniPopUp ||
                    isCurrentImageRejected) && (
                    <div className="absolute inset-0  rounded-[24px] border-solid border-[1px] border-[#FF4343]" />
                  )}
                  {/* This is to show the denied pop-up from where doc can be rejected */}
                  {showDeniedPopup && (
                    <div className="absolute inset-0 z-30 flex justify-center items-center bg-[#FF43434D]">
                      <div className="w-[442px] h-[330px] rounded-[24px]  border-solid  border-[#FF0000] border-[1px] bg-[#E8B4B4F2] px-[2px] py-[50px] flex flex-col items-center">
                        {/* Title */}
                        <h2 className="font-lufga font-normal text-[32px] leading-[100%] tracking-[-0.39px] text-center text-white capitalize">
                          Document Denied!
                        </h2>

                        {/* Subtitle */}
                        <p className="mt-[1px] font-lufga font-light text-[12px] leading-[100%] tracking-[-0.39px] text-center text-white">
                          Enter a reason why are you Denying the Document ?
                        </p>

                        {/* Reason Field */}
                        <input
                          type="text"
                          value={deniedReason}
                          onChange={(e) => setDeniedReason(e.target.value)}
                          placeholder="Type Document denied reason"
                          className="w-[332px] h-[84px] mt-[16px] rounded-[24px] border-solid border-[#FFFFFF] bg-[#FFFFFF33] px-[18px] outline-none font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-black placeholder:text-white"
                        />

                        {/* Buttons */}
                        <div className="flex items-center gap-[24px] mt-[16px]">
                          <button
                            onClick={handleDocumentReApprove}
                            className="w-[100px] h-[40px] rounded-[24px] bg-white border border-none flex items-center justify-center font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.39px] text-black capitalize"
                          >
                            Re-Approve
                          </button>

                          <button
                            onClick={handleDocumentReject}
                            className="w-[97px] h-[40px] rounded-[24px] bg-[#FF4343] border border-none flex items-center justify-center font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.39px] text-white capitalize"
                          >
                            Doc Denied
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* This is to show the denied reason with overlay */}
                  {showDeniedOverlay && showDeniedSuccessPopup && (
                    <div className="absolute inset-0 z-30 flex items-center justify-center bg-[#FF43434D]">
                      <div
                        className={`relative rounded-[24px] border-solid border-[1px] border-[#FF0000] bg-[#E8B4B4F2] ${
                          showDeniedReason
                            ? "w-[442px] min-h-[330px] px-[28px] py-[40px]"
                            : "w-[442px] h-[330px] px-[20px] py-[50px]"
                        } flex flex-col items-center`}
                      >
                        <div className="absolute top-3 right-3">
                          <img
                            src={shrinkIcon}
                            alt="icon"
                            onClick={() => {
                              setShowDeniedOverlay(false);
                              setShowDeniedSuccessPopup(false);
                              setShowDeniedMiniPopUp(true);
                            }}
                          />
                        </div>

                        {!showDeniedReason ? (
                          <>
                            {/* Title */}
                            <h2 className="font-lufga font-normal text-[32px] leading-[100%] tracking-[-0.39px] text-center text-white capitalize">
                              Document Denied!
                            </h2>

                            {/* Re-Approve */}
                            <button
                              onClick={handleDocumentReApprove}
                              className="mt-[4px] w-[100px] h-[40px] rounded-[24px] border border-none bg-white flex items-center justify-center font-lufga font-normal text-[12px] text-black"
                            >
                              Re-Approve
                            </button>

                            {/* View Reason */}
                            <button
                              onClick={() => setShowDeniedReason(true)}
                              className="mt-[18px] font-lufga font-normal border border-none text-[12px] bg-[#E8B4B4F2] leading-[100%] underline"
                            >
                              View Document Denied Reason
                            </button>
                          </>
                        ) : (
                          <>
                            {/* Title */}
                            <h2 className="font-lufga font-normal text-[32px] leading-[100%] tracking-[-0.39px] text-center text-white capitalize">
                              Document Denied!
                            </h2>

                            {/* Re-Approve */}
                            <button
                              onClick={handleDocumentReApprove}
                              className="mt-[4px] w-[100px] h-[40px] rounded-[24px] border border-none bg-white flex items-center justify-center font-lufga font-normal text-[12px] text-black"
                            >
                              Re-Approve
                            </button>

                            {/* Reason Heading */}
                            <h3 className="mt-[30px] text-center font-lufga font-normal text-[18px] text-white">
                              Document Denied Reason
                            </h3>

                            {/* Divider */}
                            <div className="w-full h-[1px] bg-[#FFFFFF33] mt-[16px]" />
                            {selectedDocument?.aiReason?.aiStatus ===
                              "REJECTED" && (
                              <>
                                {" "}
                                <div className="mt-[24px] text-white font-lufga font-[50] text-[12px] leading-[100%] tracking-[0px] text-justify capitalize">
                                  {`"${selectedDocument?.aiReason?.aiReason}" -CDP AI`}
                                </div>
                              </>
                            )}

                            {/* Reason Content */}
                            <div className="mt-[24px] text-white font-lufga font-[50] text-[12px] leading-[100%] tracking-[0px] text-justify capitalize">
                              {currentImageRejectionReason || deniedReason
                                ? `"${currentImageRejectionReason || deniedReason}" -Medical Consultant`
                                : ""}
                            </div>
                            {selectedDocument?.status === "REJECTED" &&
                              selectedDocument?.history?.rejectionReason?.map(
                                (reason) => {
                                  return (
                                    <div className="mt-[24px] text-white font-lufga font-[50] text-[12px] leading-[100%] tracking-[0px] text-justify capitalize">
                                      {`"${reason?.rejectionReason}" -Medical Consultant`}
                                    </div>
                                  );
                                },
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Thumbnails */}
                {selectedDocument?.documenturlmasters?.length > 1 && (
                  <div
                    ref={thumbnailContainerRef}
                    className="flex gap-[8px] mt-[12px] overflow-x-auto"
                  >
                    {selectedDocument.documenturlmasters.map((image, idx) => {
                      const isSelected = selectedImg?.idx === idx;
                      const isRejected = image?.status === "REJECTED";

                      return (
                        <div
                          key={image.id}
                          onClick={() => handleThumbnailClick(image, idx)}
                          className={`relative w-[99px] h-[62px] p-[2px] rounded-[8px] cursor-pointer flex-shrink-0 transition-all
${
  isRejected ? "bg-[#FF4343]" : isSelected ? "bg-[#5AC69F]" : "bg-transparent"
}`}
                        >
                          <div className="w-full h-full rounded-[6px] overflow-hidden bg-white">
                            <img
                              src={image.documentUrl}
                              alt={`thumbnail-${idx}`}
                              className="w-full h-full object-cover"
                            />
                          </div>

                          <div className="absolute top-[4px] left-[4px] z-10">
                            {isRejected ? (
                              <img
                                src={
                                  isSelected
                                    ? redThumbnailCheckedIcon
                                    : redThumbnailUncheckedIcon
                                }
                                alt="rejected-thumbnail"
                                className="w-[24px] h-[24px]"
                              />
                            ) : (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleImageSelection(image);
                                }}
                              >
                                <img
                                  src={
                                    selectedImages.some(
                                      (img) => img.id === image.id,
                                    )
                                      ? checkedThumbnailIcon
                                      : uncheckedThumbnailIcon
                                  }
                                  alt="thumbnail"
                                  className="w-[24px] h-[24px]"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Right Insights Section */}
              {!isExpandedView && (
                <div className="w-[38%] h-[calc(150vh)] rounded-[24px] bg-white overflow-y-auto px-[16px] py-[16px]">
                  {" "}
                  {/* Insights Header */}
                  <div className="flex items-center justify-between">
                    <h2 className="font-lufga font-[420] text-[24px] leading-[14px] tracking-[-0.07em] text-black">
                      Insights
                    </h2>

                    <div className="flex items-center gap-[10px]">
                      {isEditingInsights && (
                        <button
                          onClick={handleScrapDataSave}
                          className="h-[36px] px-[18px] rounded-full border border-none bg-[#5AC69F] text-white font-lufga text-[12px]"
                        >
                          SAVE
                        </button>
                      )}

                      <button
                        onClick={() => setIsEditingInsights((prev) => !prev)}
                        className="h-[36px] px-[18px] rounded-full border border-[#5AC69F] text-[#017C57] bg-white font-lufga text-[12px]"
                      >
                        {isEditingInsights ? "CANCEL" : "EDIT"}
                      </button>

                      <img src={expandIcon} alt="icon" />
                    </div>
                  </div>
                  {/* Dynamic Fields */}
                  <div className="mt-[32px] flex flex-col gap-[20px]">
                    {basicFields.map(([key, value]) => (
                      <div key={key}>
                        <p className="font-lufga font-light text-[12px] leading-[100%] tracking-[-0.07em] text-[#8B8B8B] uppercase">
                          {key.replace(/([A-Z])/g, " $1").trim()}
                        </p>

                        {isEditingInsights ? (
                          <input
                            value={editableScrapData?.[key] ?? ""}
                            onChange={(e) =>
                              setEditableScrapData((prev) => ({
                                ...prev,
                                [key]: e.target.value,
                              }))
                            }
                            className="mt-[6px] w-full border border-[#D9D9D9] rounded-[8px] px-[8px] py-[6px] font-lufga text-[14px] outline-none"
                          />
                        ) : (
                          <p className="mt-[6px] font-lufga font-light text-[14px] leading-[18px] tracking-[-0.03em] text-black break-words">
                            {value || "-"}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                  {objectFields.map(([sectionName, data]) => (
                    <div key={sectionName} className="mt-[32px]">
                      <h3 className="font-lufga font-medium text-[18px] text-black capitalize">
                        {sectionName.replace(/([A-Z])/g, " $1")}
                      </h3>

                      <div className="mt-[12px] flex flex-col gap-[12px]">
                        {Object.entries(data).map(([key, value]) => (
                          <div key={key}>
                            <p className="font-lufga font-light text-[12px] text-[#8B8B8B] uppercase">
                              {key}
                            </p>

                            {isEditingInsights ? (
                              <input
                                value={
                                  editableScrapData?.[sectionName]?.[key] || ""
                                }
                                onChange={(e) =>
                                  setEditableScrapData((prev) => ({
                                    ...prev,
                                    [sectionName]: {
                                      ...prev[sectionName],
                                      [key]: e.target.value,
                                    },
                                  }))
                                }
                                className="mt-[4px] w-full border  rounded-[8px] px-[8px] py-[6px] text-[14px] outline-none font-lufga"
                              />
                            ) : (
                              <p className="mt-[4px] font-lufga font-light text-[14px] text-black">
                                {typeof value === "object"
                                  ? JSON.stringify(value)
                                  : value || "-"}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                  {/* Dynamic Array Sections */}
                  {arrayFields.map(([fieldName, items]) => (
                    <div key={fieldName} className="mt-[40px]">
                      <h3 className="font-lufga font-medium text-[20px] leading-[20px] tracking-[-0.03em] text-black capitalize">
                        {fieldName.replace(/([A-Z])/g, " $1")}
                      </h3>

                      <div className="mt-[16px] flex flex-col gap-[16px]">
                        {items.map((item, index) => (
                          <div
                            key={index}
                            className="border border-[#00000014] rounded-[12px] p-[12px]"
                          >
                            {Object.entries(item).map(
                              ([itemKey, itemValue]) => (
                                <div
                                  key={itemKey}
                                  className="flex justify-between gap-[12px] mb-[8px]"
                                >
                                  <span className="font-lufga font-light text-[12px] text-[#8B8B8B]">
                                    {itemKey.replace(/([A-Z])/g, " $1")}
                                  </span>

                                  <span className="font-lufga font-light text-[12px] text-black text-right break-words">
                                    {typeof itemValue === "object"
                                      ? JSON.stringify(itemValue)
                                      : itemValue || "-"}
                                  </span>
                                </div>
                              ),
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                  {/* Empty State */}
                  {basicFields.length === 0 && arrayFields.length === 0 && (
                    <div className="mt-[40px] text-center">
                      <p className="font-lufga text-[14px] text-[#8B8B8B]">
                        No insights available
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Bottom Buttons */}
        </div>
      </div>
      <div className="mt-[32px] pr-12 flex justify-end items-center gap-[10px]">
        <button
          className="w-[70px] h-[42px] 3xl:w-[75px] 3xl:h-[38px] rounded-full border border-none bg-black flex justify-center items-center gap-[8px] font-lufga font-normal text-[14px] text-[#68FF9F]"
          onClick={() => setShowAll(!showAll)}
        >
          {/* Eye Icon */}
          <img src={eyeNewIcon} width={14} height={11} alt="new icon" />
          ALL
        </button>

        {/* SAVE ALL Button */}
        <button
          className="w-[120px] h-[42px] 3xl:w-[89px] 3xl:h-[38px] rounded-full border border-none bg-black flex justify-center items-center font-lufga font-normal text-[14px] text-[#68FF9F]"
          onClick={() => setSaveAll((prev) => prev + 1)}
        >
          SAVE ALL
        </button>
      </div>
      <div className="pb-[70px] max-h-[50vh] overflow-y-auto rounded-[16px] mt-3">
        <NewDutAccordion
          dutData={dutData}
          showAll={showAll}
          saveAll={saveAll}
        />
      </div>{" "}
      {/* Footer Buttons */}
      <div
        className="fixed bottom-0 left-[172px] right-0 z-50 flex border-t border-white/20 bg-white/10 backdrop-blur-sm backdrop-saturate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] mx-2 py-3
  "
      >
        {" "}
        <div className="flex-1 flex justify-center items-center gap-[14px] ">
          {submitting ? (
            <CircularProgress />
          ) : (
            <>
              <button
                className="w-[61px] h-[40px]  rounded-[24px] border border-[#5AC69F] bg-transparent flex justify-center items-center px-[14px] py-[14px] font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.35px] uppercase text-[#1A1A1A]"
                onClick={() => {
                  if (window.confirm("Do you want to proceed")) {
                    handleHoldClick();
                  }
                }}
              >
                HOLD
              </button>
              <button
                className="w-[95px] h-[41px] border border-none rounded-[24px] bg-black flex justify-center items-center gap-[8px] pt-[12px] pr-[14px] pb-[12px] pl-[14px]"
                onClick={() => {
                  if (window.confirm("Do you want to proceed")) {
                    handleSubmitClick();
                  }
                }}
              >
                <span className="font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.35px] uppercase text-[#5AC69F]">
                  SUBMIT
                </span>
                <span className="text-[#5AC69F] text-[22px] leading-none">
                  →
                </span>
              </button>
            </>
          )}
        </div>
        <div className="flex items-center justify-end gap-2 xl:pr-12 2xl:pr-12 3xl:pr-10">
          <div
            className="flex items-center gap-1 cursor-pointer border border-solid border-black px-[14px] py-[14px] rounded-full"
            onClick={() => handleReprocessAiCase(selectedCase)}
          >
            <img src={RefreshIcon} alt="refresh-icon" />{" "}
            <div className=" font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.35px] uppercase text-[#1A1A1A]">
              AI Analysis
            </div>
          </div>
          <div
            className="relative cursor-pointer"
            onClick={() => setOpenChatBox((prev) => !prev)}
          >
            <img src={blackChatIcon} alt="chat icon" width={32} height={32} />

            {selectedImg?.totalUnreadComments > 0 && (
              <div className="absolute -top-[8px] -left-[8px] min-w-[20px] h-[20px] rounded-full bg-[#FF4343] flex items-center justify-center px-[4px]">
                <span className="text-white text-[10px] font-medium font-lufga">
                  {selectedImg?.totalUnreadComments > 99
                    ? "99+"
                    : selectedImg?.totalUnreadComments}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      {openMultipleDownloads && (
        <DownloadMultipleDocuments
          setOpen={setOpenMultipleDownloads}
          images={selectedDocument?.documenturlmasters}
          documentName={selectedDocument?.documentName}
          tmsVersion="2.0"
          hideCompressedDownload={true}
        />
      )}
      {openChatBox && (
        <div className="fixed bottom-[150px] right-[24px] z-[100]">
          <div className="w-[523px] h-[448px] xl:w-[580px] xl:h-[350px] rounded-[32px] bg-[#EEF7F3]  border border-[#E8E8E8] shadow-lg p-[16px] flex flex-col gap-[12px] relative">
            <button
              onClick={() => setOpenChatBox(false)}
              className="absolute top-[12px] right-[16px] bg-transparent border-none text-[28px] cursor-pointer text-black"
            >
              <img src={crossNewIcon} alt="new icon" width={20} height={20} />
            </button>

            <div
              ref={chatContainerRef}
              className="flex-1 overflow-y-auto flex flex-col gap-[16px] pr-[4px]"
            >
              {" "}
              {comments.map((comment, idx) => (
                <div key={idx}>
                  {comment?.from === user?.user?.id ? (
                    <div className="flex justify-end gap-[12px] mr-6">
                      <div className="w-[387px] min-h-[91px] rounded-[15px] px-[11px] py-[8px] backdrop-blur-[24px] bg-[#5AC69F99] text-white flex flex-col gap-[1px] relative">
                        <div className="flex justify-end items-center gap-[10px]">
                          <span className="font-lufga font-medium text-[16px] text-white">
                            You
                          </span>

                          <div className="w-[34px] h-[34px] rounded-full bg-white flex items-center justify-center">
                            <img
                              src={settlemedLogo}
                              alt="settlemed"
                              className="w-[25px] h-[25px] object-contain"
                            />
                          </div>
                        </div>

                        <p className="font-lufga font-light text-[12px] leading-[18px] text-white">
                          {comment?.message}
                        </p>

                        <p className="font-lufga font-light text-[11px] text-white opacity-90">
                          {new Date(comment?.createdAt).toLocaleDateString()}{" "}
                          {new Date(comment?.createdAt).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-start gap-[12px]">
                      <div className="w-[387px] min-h-[91px] bg-[#FFFFFF] rounded-[24px] px-[16px] py-[14px]">
                        <div className="flex items-center gap-[8px]">
                          <div className="w-[34px] h-[34px] rounded-full bg-white flex items-center justify-center shrink-0">
                            <img
                              src={hospitalIcon}
                              alt="hospital"
                              className="w-[25px] h-[25px] object-contain"
                            />
                          </div>

                          <p className="font-lufga font-medium text-[10.65px] leading-[11.41px] tracking-[-0.38px] text-black capitalize">
                            {users?.[comment?.from]?.fullName || "Hospital"}
                          </p>
                        </div>

                        <p className="mt-[8px] font-lufga text-[13px] leading-[18px] text-[#1A1A1A]">
                          {comment?.message}
                        </p>

                        <p className="mt-[8px] text-[11px] text-[#8B8B8B]">
                          {new Date(comment?.createdAt).toLocaleDateString()}{" "}
                          {new Date(comment?.createdAt).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="absolute left-0 right-0 -bottom-[72px] px-[16px]">
              <div className="w-[523px] h-[64px] bg-[#FFFFFF] rounded-full shadow-lg flex items-center px-[18px]">
                <div className="text-[22px] mr-[12px] cursor-pointer">
                  <img
                    src={clippedIcon}
                    alt="clipped icon"
                    height={17}
                    width={16}
                  />
                </div>

                <input
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && message.trim()) {
                      e.preventDefault();
                      handleCommentAdd();
                    }
                  }}
                  placeholder="Type a message..."
                  className="flex-1 border-none outline-none bg-transparent font-lufga text-[14px] text-black"
                />

                <button
                  onClick={handleCommentAdd}
                  className="w-[56px] h-[56px] rounded-full bg-black flex items-center justify-center border-none cursor-pointer"
                >
                  {/* <span className="text-white text-[22px]">➤</span> */}
                  <img src={SendIcon} alt="send icon" width={35} height={35} />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClaimInsightsScreen;
